import React from 'react';
import {
  string, node, bool,
} from 'prop-types';
import classnames from 'classnames';
import Grid from '@active/react-ui/Grid';
import GridItem from '@active/react-ui/GridItem';
import { Header, FooterContainer } from '../../banners/PageBanners';
import ContainerAlert from '../ContainerAlert';

const Container = ({
  className,
  children,
  isShowBanner,
  showErrorMsgOnly,
  errorActions,
  ...rest
}) => {
  const classes = classnames({
    'checkout-ui-container': true,
    'container-view-height': isShowBanner,
    'checkout-ui-component': true,
  }, className);
  return (
    <div className={classes}>
      <div className="checkout-ui-container__north">
        {isShowBanner && <Header />}
      </div>
      <div className="checkout-ui-container__main">
        { showErrorMsgOnly ? <Grid>
          <GridItem span={12} spanXl={8} >
            {errorActions && <ContainerAlert errorActions={errorActions}/>}
          </GridItem>
        </Grid> : children}
      </div>
      <div className="checkout-ui-container__south">
        {isShowBanner && <FooterContainer {...rest}/>}
      </div>
    </div>
  );
};

Container.propTypes = {
  children: node,
  className: string,
  isShowBanner: bool,
  showErrorMsgOnly: bool,
};

Container.defaultProps = {
  isShowBanner: false,
  showErrorMsgOnly: false,
};

export default Container;
